module.exports = __webpack_public_path__ + "static/img/1_02_m.2963f125.jpg";